// extracted by mini-css-extract-plugin
var _1 = "CalendarGridDayPopover-modulecompact__F3gwp";
var _2 = "CalendarGridDayPopover-modulemessage__aL6dx CalendarGridBodyMessage-moduleCalendarGridBodyMessage__w70n9";
var _3 = "CalendarGridDayPopover-modulerows__Dcjmq";
export { _1 as "compact", _2 as "message", _3 as "rows" }
